module.exports = __webpack_public_path__ + "static/media/flower9.51e418cb.png";